import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IInProcessPaymentTransacitonsToolbar {
	onCreatePaymentFileButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onSaveButtonClickedHandler: () => void
	onUndoButtonClickedHandler: () => void
	onProccessedButtonClickedHandler: () => void
	onErrorInTransactionButtonClickedHandler: () => void
}

export const InProcessPaymentTransacitonsToolbar: FC<IInProcessPaymentTransacitonsToolbar> = ({
	onCreatePaymentFileButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onSaveButtonClickedHandler,
	onUndoButtonClickedHandler,
	onProccessedButtonClickedHandler,
	onErrorInTransactionButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Create Payment File"
					onClickHandler={onCreatePaymentFileButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSaveButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Undo"
					raised
					onClickHandler={onUndoButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				<EnhancedButtonPrimeReact
					label="Proccessed"
					onClickHandler={onProccessedButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Error in Transaction"
					raised
					onClickHandler={onErrorInTransactionButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Toolbar>
		</AppBar>
	);
};
